import React from 'react';
import { Paper } from '@mui/material';

export const CustomPaper: React.FC = (props: any) => {
    return <Paper {...props} sx={{backgroundColor: 'background.default'}} />
}
